import { DATA_KEY } from './constants';
import { isLocalStorageAvailable } from '../isLocalStorageAvailable';
export function clear() {
  if (isLocalStorageAvailable()) {
    window.localStorage.removeItem(DATA_KEY);
  }
}